import React from 'react';
import GenderPieChart from './GenderPieChart';
import AgeRangeBarChart from './AgeRangeBarChart';

interface AudienceStatsProps {
  genderStats: {
    genderDistribution: {
      male: string;
      female: string;
    };
    ageRangeData: {
      categories: string[];
      data: number[];
    };
    genderPieData: {
      labels: string[];
      series: number[];
    };
    totalImpressions: number;
  } | null;
}

const AudienceStats: React.FC<AudienceStatsProps> = ({ genderStats }) => {
  if (!genderStats) return null;

  return (
    <>
      <div className="lg:mt-8 mt-5 mb-5">
        <p className="lg:text-[28px] text-[20px] font-semibold text-black font-inter">Your Top Audiences</p>
        <p className="lg:text-base text-sm font-inter font-normal text-[#4A4D4F] lg:mt-0 mt-2">
        See Who’s Engaging the Most with Your Campaigns.
        </p>
      </div>
      <div className="flex lg:flex-row flex-col items-stretch lg:space-x-4 lg:space-y-0 space-y-4 justify-between">
        <GenderPieChart 
          labels={genderStats.genderPieData.labels}
          series={genderStats.genderPieData.series}
          genderDistribution={genderStats.genderDistribution}
        />
        <AgeRangeBarChart 
          categories={genderStats.ageRangeData.categories}
          data={genderStats.ageRangeData.data}
        />
      </div>
    </>
  );
};

export default AudienceStats;